/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * API Сервиса Маркет (Adopt Me) #market #adopt_me
 * OpenAPI spec version: 1.0.0
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

import type { BodyType, ErrorType } from '../../axios-client';
import { useCustomClient } from '../../axios-client';
import type {
  DeleteOrdersId200,
  DeleteOrdersId404,
  DeleteOrdersId409,
  GetOrders200,
  GetOrdersId200,
  GetOrdersSales200,
  PatchOrdersIdPaymentMethod200,
  PatchOrdersIdPaymentMethod400,
  PatchOrdersIdPaymentMethod404,
  PatchOrdersIdPaymentMethodBody,
  PatchOrdersIdUseBalance200,
  PatchOrdersIdUseBalance400,
  PatchOrdersIdUseBalance404,
  PatchOrdersIdUseBalanceBody,
  PostOrdersIdPay200,
  PostOrdersIdPay404,
} from '.././models';

/**
 * @summary Получить все заказы 🔓
 */
export const useGetOrdersHook = () => {
  const getOrders = useCustomClient<GetOrders200>();

  return useCallback(
    (signal?: AbortSignal) => {
      return getOrders({ url: '/orders', method: 'GET', signal });
    },
    [getOrders],
  );
};

export const getGetOrdersQueryKey = () => {
  return ['/orders'] as const;
};

export const useGetOrdersInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>
  >,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrdersQueryKey();

  const getOrders = useGetOrdersHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>
  > = ({ signal }) => getOrders(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrdersInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>
>;
export type GetOrdersInfiniteQueryError = ErrorType<unknown>;

export function useGetOrdersInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>
  >,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>,
        TError,
        Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>
      >,
      'initialData'
    >;
}): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrdersInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>
  >,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>,
        TError,
        Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>
      >,
      'initialData'
    >;
}): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrdersInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>
  >,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>,
      TError,
      TData
    >
  >;
}): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Получить все заказы 🔓
 */

export function useGetOrdersInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>
  >,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>,
      TError,
      TData
    >
  >;
}): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetOrdersInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useGetOrdersQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrdersQueryKey();

  const getOrders = useGetOrdersHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>
  > = ({ signal }) => getOrders(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrdersQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>
>;
export type GetOrdersQueryError = ErrorType<unknown>;

export function useGetOrders<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>,
        TError,
        Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrders<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>,
        TError,
        Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrders<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Получить все заказы 🔓
 */

export function useGetOrders<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetOrdersHook>>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetOrdersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить заказ 🔓
 */
export const useGetOrdersIdHook = () => {
  const getOrdersId = useCustomClient<GetOrdersId200>();

  return useCallback(
    (id: number, signal?: AbortSignal) => {
      return getOrdersId({ url: `/orders/${id}`, method: 'GET', signal });
    },
    [getOrdersId],
  );
};

export const getGetOrdersIdQueryKey = (id: number) => {
  return [`/orders/${id}`] as const;
};

export const useGetOrdersIdInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>
  >,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrdersIdQueryKey(id);

  const getOrdersId = useGetOrdersIdHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>
  > = ({ signal }) => getOrdersId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrdersIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>
>;
export type GetOrdersIdInfiniteQueryError = ErrorType<unknown>;

export function useGetOrdersIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>
  >,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>
        >,
        'initialData'
      >;
  },
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrdersIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>
  >,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>
        >,
        'initialData'
      >;
  },
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrdersIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>
  >,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>,
        TError,
        TData
      >
    >;
  },
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Получить заказ 🔓
 */

export function useGetOrdersIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>
  >,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>,
        TError,
        TData
      >
    >;
  },
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetOrdersIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useGetOrdersIdQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrdersIdQueryKey(id);

  const getOrdersId = useGetOrdersIdHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>
  > = ({ signal }) => getOrdersId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrdersIdQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>
>;
export type GetOrdersIdQueryError = ErrorType<unknown>;

export function useGetOrdersId<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrdersId<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrdersId<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Получить заказ 🔓
 */

export function useGetOrdersId<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOrdersIdHook>>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetOrdersIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Отменить заказ 🔓
 */
export const useDeleteOrdersIdHook = () => {
  const deleteOrdersId = useCustomClient<DeleteOrdersId200>();

  return useCallback(
    (id: number) => {
      return deleteOrdersId({ url: `/orders/${id}`, method: 'DELETE' });
    },
    [deleteOrdersId],
  );
};

export const useDeleteOrdersIdMutationOptions = <
  TError = ErrorType<DeleteOrdersId404 | DeleteOrdersId409>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteOrdersIdHook>>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDeleteOrdersIdHook>>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteOrdersId'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const deleteOrdersId = useDeleteOrdersIdHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDeleteOrdersIdHook>>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deleteOrdersId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteOrdersIdMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDeleteOrdersIdHook>>>
>;

export type DeleteOrdersIdMutationError = ErrorType<
  DeleteOrdersId404 | DeleteOrdersId409
>;

/**
 * @summary Отменить заказ 🔓
 */
export const useDeleteOrdersId = <
  TError = ErrorType<DeleteOrdersId404 | DeleteOrdersId409>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteOrdersIdHook>>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDeleteOrdersIdHook>>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = useDeleteOrdersIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Менять метод оплаты заказа 🔓
 */
export const usePatchOrdersIdPaymentMethodHook = () => {
  const patchOrdersIdPaymentMethod =
    useCustomClient<PatchOrdersIdPaymentMethod200>();

  return useCallback(
    (
      id: number,
      patchOrdersIdPaymentMethodBody: BodyType<PatchOrdersIdPaymentMethodBody>,
    ) => {
      return patchOrdersIdPaymentMethod({
        url: `/orders/${id}/payment-method`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: patchOrdersIdPaymentMethodBody,
      });
    },
    [patchOrdersIdPaymentMethod],
  );
};

export const usePatchOrdersIdPaymentMethodMutationOptions = <
  TError = ErrorType<
    PatchOrdersIdPaymentMethod400 | PatchOrdersIdPaymentMethod404
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePatchOrdersIdPaymentMethodHook>>>,
    TError,
    { id: number; data: BodyType<PatchOrdersIdPaymentMethodBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof usePatchOrdersIdPaymentMethodHook>>>,
  TError,
  { id: number; data: BodyType<PatchOrdersIdPaymentMethodBody> },
  TContext
> => {
  const mutationKey = ['patchOrdersIdPaymentMethod'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const patchOrdersIdPaymentMethod = usePatchOrdersIdPaymentMethodHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof usePatchOrdersIdPaymentMethodHook>>>,
    { id: number; data: BodyType<PatchOrdersIdPaymentMethodBody> }
  > = props => {
    const { id, data } = props ?? {};

    return patchOrdersIdPaymentMethod(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchOrdersIdPaymentMethodMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePatchOrdersIdPaymentMethodHook>>>
>;
export type PatchOrdersIdPaymentMethodMutationBody =
  BodyType<PatchOrdersIdPaymentMethodBody>;
export type PatchOrdersIdPaymentMethodMutationError = ErrorType<
  PatchOrdersIdPaymentMethod400 | PatchOrdersIdPaymentMethod404
>;

/**
 * @summary Менять метод оплаты заказа 🔓
 */
export const usePatchOrdersIdPaymentMethod = <
  TError = ErrorType<
    PatchOrdersIdPaymentMethod400 | PatchOrdersIdPaymentMethod404
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePatchOrdersIdPaymentMethodHook>>>,
    TError,
    { id: number; data: BodyType<PatchOrdersIdPaymentMethodBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof usePatchOrdersIdPaymentMethodHook>>>,
  TError,
  { id: number; data: BodyType<PatchOrdersIdPaymentMethodBody> },
  TContext
> => {
  const mutationOptions = usePatchOrdersIdPaymentMethodMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Менять опцию использования баланса в заказе 🔓
 */
export const usePatchOrdersIdUseBalanceHook = () => {
  const patchOrdersIdUseBalance = useCustomClient<PatchOrdersIdUseBalance200>();

  return useCallback(
    (
      id: number,
      patchOrdersIdUseBalanceBody: BodyType<PatchOrdersIdUseBalanceBody>,
    ) => {
      return patchOrdersIdUseBalance({
        url: `/orders/${id}/use-balance`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: patchOrdersIdUseBalanceBody,
      });
    },
    [patchOrdersIdUseBalance],
  );
};

export const usePatchOrdersIdUseBalanceMutationOptions = <
  TError = ErrorType<PatchOrdersIdUseBalance400 | PatchOrdersIdUseBalance404>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePatchOrdersIdUseBalanceHook>>>,
    TError,
    { id: number; data: BodyType<PatchOrdersIdUseBalanceBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof usePatchOrdersIdUseBalanceHook>>>,
  TError,
  { id: number; data: BodyType<PatchOrdersIdUseBalanceBody> },
  TContext
> => {
  const mutationKey = ['patchOrdersIdUseBalance'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const patchOrdersIdUseBalance = usePatchOrdersIdUseBalanceHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof usePatchOrdersIdUseBalanceHook>>>,
    { id: number; data: BodyType<PatchOrdersIdUseBalanceBody> }
  > = props => {
    const { id, data } = props ?? {};

    return patchOrdersIdUseBalance(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchOrdersIdUseBalanceMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePatchOrdersIdUseBalanceHook>>>
>;
export type PatchOrdersIdUseBalanceMutationBody =
  BodyType<PatchOrdersIdUseBalanceBody>;
export type PatchOrdersIdUseBalanceMutationError = ErrorType<
  PatchOrdersIdUseBalance400 | PatchOrdersIdUseBalance404
>;

/**
 * @summary Менять опцию использования баланса в заказе 🔓
 */
export const usePatchOrdersIdUseBalance = <
  TError = ErrorType<PatchOrdersIdUseBalance400 | PatchOrdersIdUseBalance404>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePatchOrdersIdUseBalanceHook>>>,
    TError,
    { id: number; data: BodyType<PatchOrdersIdUseBalanceBody> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof usePatchOrdersIdUseBalanceHook>>>,
  TError,
  { id: number; data: BodyType<PatchOrdersIdUseBalanceBody> },
  TContext
> => {
  const mutationOptions = usePatchOrdersIdUseBalanceMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Получить ссылку на оплату заказа 🔓
 */
export const usePostOrdersIdPayHook = () => {
  const postOrdersIdPay = useCustomClient<PostOrdersIdPay200>();

  return useCallback(
    (id: number, signal?: AbortSignal) => {
      return postOrdersIdPay({
        url: `/orders/${id}/pay`,
        method: 'POST',
        signal,
      });
    },
    [postOrdersIdPay],
  );
};

export const usePostOrdersIdPayMutationOptions = <
  TError = ErrorType<PostOrdersIdPay404>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostOrdersIdPayHook>>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof usePostOrdersIdPayHook>>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['postOrdersIdPay'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const postOrdersIdPay = usePostOrdersIdPayHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof usePostOrdersIdPayHook>>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return postOrdersIdPay(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostOrdersIdPayMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePostOrdersIdPayHook>>>
>;

export type PostOrdersIdPayMutationError = ErrorType<PostOrdersIdPay404>;

/**
 * @summary Получить ссылку на оплату заказа 🔓
 */
export const usePostOrdersIdPay = <
  TError = ErrorType<PostOrdersIdPay404>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostOrdersIdPayHook>>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof usePostOrdersIdPayHook>>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = usePostOrdersIdPayMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Последние продажи
 */
export const useGetOrdersSalesHook = () => {
  const getOrdersSales = useCustomClient<GetOrdersSales200>();

  return useCallback(
    (signal?: AbortSignal) => {
      return getOrdersSales({ url: '/orders/sales', method: 'GET', signal });
    },
    [getOrdersSales],
  );
};

export const getGetOrdersSalesQueryKey = () => {
  return ['/orders/sales'] as const;
};

export const useGetOrdersSalesInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>
  >,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrdersSalesQueryKey();

  const getOrdersSales = useGetOrdersSalesHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>
  > = ({ signal }) => getOrdersSales(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrdersSalesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>
>;
export type GetOrdersSalesInfiniteQueryError = ErrorType<unknown>;

export function useGetOrdersSalesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>
  >,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>,
        TError,
        Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>
      >,
      'initialData'
    >;
}): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrdersSalesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>
  >,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>,
        TError,
        Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>
      >,
      'initialData'
    >;
}): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrdersSalesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>
  >,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>,
      TError,
      TData
    >
  >;
}): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Последние продажи
 */

export function useGetOrdersSalesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>
  >,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>,
      TError,
      TData
    >
  >;
}): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetOrdersSalesInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useGetOrdersSalesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrdersSalesQueryKey();

  const getOrdersSales = useGetOrdersSalesHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>
  > = ({ signal }) => getOrdersSales(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrdersSalesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>
>;
export type GetOrdersSalesQueryError = ErrorType<unknown>;

export function useGetOrdersSales<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>,
        TError,
        Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrdersSales<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>,
        TError,
        Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrdersSales<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Последние продажи
 */

export function useGetOrdersSales<
  TData = Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useGetOrdersSalesHook>>>,
      TError,
      TData
    >
  >;
}): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetOrdersSalesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
